import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $, { parseJSON } from 'jquery';
import Select from 'react-select';
import CKEditor from 'ckeditor4-react';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { mediaUrl,apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';



class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const tabId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		this.state = {
            tabId: tabId,
			tab_name:'',
			description:'',
			title:'',
			content:'',
			Loading:false,
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			image_name: [],
			image_preview: [],
			image:[],
			old_image:[],
			image_fileExtension:[],
			allImgArray : [],
			apply_on_maintab : false,
			apply_on_innertab : false,
			old_tab_icon : '',

			priority: '',
			selLinkOption:'',
			selLinkValue:'',
			selLinkFunc:'',
			selLinkLabel:'',
			selUserTypeOption:'',
			selUserTypeValue:'',
			selUserTypeLabel:'',
			selAccessTypeOption:'',
			selAccessTypeValue:'',
			selAccessTypeLabel:'',
			accessType:'ai',
			loggedSt:'Both',		
		};
		// this.props.getCategoryDetailList(tabId);
		var qs = require('qs');
		var catid = this.state.tabId;

		axios.get(apiUrl+"tabmanagement/listdetail?id="+catid).then(res => {
			
			this.setState({tab_name:res.data.tablist.name,description:res.data.tablist.description,title:res.data.tablist.title,content:res.data.tablist.content,button_text:res.data.tablist.button_text,tab_icon:res.data.tablist.tab_icon,content_type:res.data.tablist.content_type, selAccessTypeValue : res.data.tablist.access_type, priority : res.data.tablist.priority, selLinkValue : res.data.tablist.link, selUserTypeValue : res.data.tablist.loggedSt});
			if(res.data.tablist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}

			this.setState({selLinkOption:{value: res.data.tablist.link, label: res.data.tablist.name}});
			this.setState({selUserTypeOption:{value: res.data.tablist.loggedSt, label: res.data.tablist.loggedSt}});
			this.setState({selAccessTypeOption:{value: res.data.tablist.access_type, label: res.data.tablist.access_type}});
			
			if(res.data.tablist.apply_on_maintab === 'Y'){
				this.setState({apply_on_maintab:true});
			}else{
			this.setState({apply_on_maintab:false});
			}

			if(res.data.tablist.apply_on_innertab === 'Y'){
				this.setState({apply_on_innertab:true});
			}else{
			this.setState({apply_on_innertab:false});
			}
			
			if(res.data.tablist.image != ''){
				
				this.setState({old_image:parseJSON(res.data.tablist.image)});
			}
			if(res.data.tablist.tab_icon !== null){
				this.setState({old_tab_icon:res.data.tablist.tab_icon});
			}
		}); 
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
		this.onChangeMultipleHandler = this.onChangeMultipleHandler.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);

    }

    handleChange = selectedOption => {

        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	handleOptionChange = (optVal, type) => {
		if(type === 'linkOption'){
			this.setState({	selLinkOption:optVal })
			this.setState({  selLinkLabel : optVal.label, selLinkValue : optVal.value });
		}
		else if(type === 'userTypeOption'){
			this.setState({	selUserTypeOption:optVal })
			this.setState({  selUserTypeLabel : optVal.label, selUserTypeValue : optVal.value });
		}
		else if(type === 'accessTypeOption'){	
			this.setState({	selAccessTypeOption:optVal })
			this.setState({  selAccessTypeLabel : optVal.label, selAccessTypeValue : optVal.value });
		}	
   	};
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
      if(name === 'apply_on_maintab'){
      	this.setState({apply_on_maintab: !this.state.apply_on_maintab});
      } 
	  if(name === 'apply_on_innertab'){
			this.setState({apply_on_innertab: !this.state.apply_on_innertab});
		} 	


		
    }

	componentDidMount() {
		document.title = PageTitle('Tab Edit');
    }

	
        handleFormSubmit = () => {
			if(this.validateForm()){ 
				this.setState({Loading:true});
				
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}

				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					tab_name: formPayload.tab_name,
					// title : formPayload.title,
					// tab_description: localStorage.getItem("tab_content"),
					// content: formPayload.content,
					status:  status,
					// apply_on_maintab: formPayload.apply_on_maintab,
					// apply_on_innertab: formPayload.apply_on_innertab,
					// button_text: formPayload.button_text,
					id : this.state.tabId,
					old_tab_icon : this.state.old_tab_icon,
					//content_type : this.state.content_type,

					accessType : formPayload.selAccessTypeValue,
					loggedSt : formPayload.selUserTypeValue,
					linkTo : formPayload.selLinkValue,
					priority: formPayload.priority,
				
				};
				let formData = new FormData();
				
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}		       
				var imgdata = formPayload.allImgArray;
				for (var i in imgdata) {
					formData.append('images[]',imgdata[i])
				}
				var oldImgdata = (formPayload.old_image.length > 0) ? formPayload.old_image : '';				
				formData.append('old_images',oldImgdata)
				


				var icondata = formPayload.icon;
				formData.append('file',icondata)
				
				axios.post(apiUrl+"tabmanagement/edit",formData ).then(res => {
					if(res.data.status === "success"){	
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
								setTimeout(
								function() {
									$('.success_message').html(this.props.history.push('/tabmanagement'));
								}
								.bind(this),
								3000
								);
								localStorage.removeItem('tab_content');
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					}
				});
			}
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		const {tab_name,title , apply_on_maintab , apply_on_innertab , button_text  , content_type, accessType, selLinkValue, selUserTypeValue, selAccessTypeValue}   = this.state;
		let errors = {};
      	let formIsValid = true;
		var description = localStorage.getItem("tab_content");
		
		if (!tab_name) {
			formIsValid = false;
			$('.errortab_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(tab_name){
			$('.errortab_name').html('');
		}
		
		// if (!title) {
		// 	formIsValid = false;
		// 	$('.errortab_title').html('<span class="errorspan">Please fill the field</span>');
		// }else if(tab_name){
		// 	$('.errortab_title').html('');
		// }

		// if(accessType == 'mainTab'){
		// 	if (!description) {
		// 		formIsValid = false;
		// 		$('.errordescription').html('<span class="errorspan">Please fill the field</span>');
		// 	}else if(description){
		// 		$('.errordescription').html('');
		// 	}
	
		// 	if(!apply_on_maintab && !apply_on_innertab){
		// 		formIsValid = false;
		// 		$('.errorapplyon').html('<span class="errorspan">Please select atleast one option</span>');
		// 	}else{
		// 		$('.errorapplyon').html('');
		// 	}
	
		// 	if (!button_text) {
		// 		formIsValid = false;
		// 		$('.errorbuttontext').html('<span class="errorspan">Please fill the field</span>');
		// 	}else if(description){
		// 		$('.errorbuttontext').html('');
		// 	}
	
		// 	if (!content_type) {
		// 		formIsValid = false;
		// 		$('.error_contenttype').html('<span class="errorspan">Please select atleast one option</span>');
		// 	}else if(description){
		// 		$('.error_contenttype').html('');
		// 	}
		// }
		//else if(accessType == 'ai'){
			
			if (!selLinkValue) {
				formIsValid = false;
				$('.errorselSubmenuValue').html('<span class="errorspan">Please fill the field</span>');
			}else if(selLinkValue){
				$('.errorselSubmenuValue').html('');
			}
			if (!selUserTypeValue) {
				formIsValid = false;
				$('.errorselUserTypeValue').html('<span class="errorspan">Please fill the field</span>');
			}else if(selUserTypeValue){
				$('.errorselUserTypeValue').html('');
			}
			if (!selAccessTypeValue) {
				formIsValid = false;
				$('.errorselAccessTypeValue').html('<span class="errorspan">Please fill the field</span>');
			}else if(selAccessTypeValue){
				$('.errorselAccessTypeValue').html('');
			}
		//}

		

		this.setState({
			errors: errors
		});
		return formIsValid;
    }


	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
		  this.setState({
			icon_name: file.name,
			icon_preview: reader.result,
			icon: file,
			icon_fileExtension:extension,
			
		  });
		};
		reader.readAsDataURL(file);
		
	  } 

	  onChangeMultipleHandler= e => {
		this.fileObj = [];
		this.fileNameArray = this.state.image_name;
		this.fileArray = this.state.image;
		this.extensionArray = this.state.image_fileExtension;
		this.image_preview = this.state.image_preview;
		this.allImgArray = this.state.allImgArray;
		this.fileObj.push(e.target.files);
		for (let i = 0; i < this.fileObj[0].length; i++) {
			this.fileNameArray.push(this.fileObj[0][i].name)
			this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
			this.allImgArray.push(this.fileObj[0][i])
			this.extensionArray.push(this.fileObj[0][i].name.split('.').pop());
			
		}
		
		this.setState({
			image_name: this.fileNameArray,
			image_preview: this.image_preview,
			image: this.fileArray,
			image_fileExtension:this.extensionArray,
			
		  });
		
	  }
	  
	removeImagebyindex = (indexvalue) => {
		var list = this.state.image;
		var allImgArray = this.state.allImgArray;
		
		this.imageArray = [];
		this.fileArray = [];
		list.splice(indexvalue, 1);
		allImgArray.splice(indexvalue,1)

	
		this.setState({ image: list , allImgArray : allImgArray })
		
	}

	OldremoveImagebyindex = (indexvalue) => {
		var list = this.state.old_image;
		console.log(list,'list')
		list.splice(indexvalue, 1);
		console.log(list,'list')

		this.setState({ old_image: list })
		
	}

	onEditorChange( evt ) {
    	// console.log(evt.editor.getData())
    	// var callfunc = this;
    	// setTimeout(function () {
		// callfunc.setState( {
        //     terms_and_condition: evt.editor.getData()
        // } );
		// }, 1000);
		localStorage.setItem('tab_content',evt.editor.getData())
     
    }

	render() {

		const {selectedOption} = this.state;
		
		var oldImgThumblist;
		var imgThumblist ;
		let indexlength =  this.state.image.length;
		if(this.state.old_image.length > 0){
			oldImgThumblist =  this.state.old_image.map((url,index) => (
				<li className="thumb" key={indexlength+index}  >
					<span><img src={mediaUrl+'gallery/'+url}  alt="..." /></span>
					<a href="javascript:void(0);" onClick={this.OldremoveImagebyindex.bind(this,index)}>X</a>
				</li>
			));
		}  
		if(this.state.image.length > 0){
		
			imgThumblist =  this.state.image.map((url,index) => (
				<li className="thumb" key={indexlength+index}  >
					<span><img src={url}  alt="..." /></span>
					<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
				</li>
			));
		}
		var	preview = (this.state.icon_preview) ? 
		<img className="img_class" src={this.state.icon_preview} alt="" /> :
		<img className="img_class" src={mediaUrl+'tabicons/'+this.state.old_tab_icon} alt="" />
		;
		
		return (
			<div className="wrapper"> 
		
				<Header />
				<MenuSidebar currentpage="tabmanagement" />  
				<div className="content">	
					<div className="content-wrapper">
						<div class="content-wrapper-before"></div>
						<div className="form-wrapper leaa-admin-head card">
							<div className="success_message"></div>
							<div className="title">
								<h4>Edit Details</h4>
								<a className="" href='/tabmanagement'><span class="close">X</span></a>	
							</div>
							<form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
								<div className="form-row">
									<div className="form-left">
										<div className="form-group">
											<label> Name<span class="required" style={{ color: "red" }} > * </span> : </label>
											<input type="text" name="tab_name" onChange={this.handleInputChange} className="form-control" value={this.state.tab_name} />
											<div className="errortab_name"></div>
										</div>
										<div className="form-group" style={{ marginTop: '20px' }}>
											<label>User Access :</label>

											{/* <input onChange={this.handleInputChange} type="radio" name="loggedSt" value="Guest" checked={(this.state.loggedSt == "Guest" ? "checked" : "" )}/>
											Guest
											<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Logged In" checked={(this.state.loggedSt == "Logged In" ? "checked" : "" )}/>
											Logged In
											<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Both" checked={(this.state.loggedSt == "Both" ? "checked" : "" )}/>
											Both								 */}
											<Select 
												name="User Type"
												value={this.state.selUserTypeOption? this.state.selUserTypeOption:{ value: '', label: 'Select'}}
												options={lang.common.tab_login_type} 
												isSearchable = {false}
												//onChange={this.handleOptionChange('userTypeOption')}
												onChange={(optVal) => this.handleOptionChange(optVal, 'userTypeOption')}

											/>
											<div className="errorselUserTypeValue"></div>
										</div>
										<div className="form-group">
											<label>Priority: </label>
											<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
											<div className="errorpriority"></div>
										</div>
										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											onChange={this.handleChange}
											/>
										</div> 
									</div>
									
									<div className="form-right">

										{/* <div className="form-group">
											<label>Title<span class="required" style={{ color: "red" }} > * </span> : </label>
											<input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title}/>
											<div className="errortab_title"></div>
										</div> */}
										<div className="form-group">
											<label>Link to<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											name="status"
											value={this.state.selLinkOption? this.state.selLinkOption:{ value: '', label: 'Select'}}
											options={lang.common.sidebar_ai_options} 
											isSearchable = {false}
											onChange={this.handleOptionChange}
											/>
											<div className="errorselSubmenuValue"></div>
										</div> 
										<div className="form-group z-index-999" style={{ marginTop: '20px' }}>										
											<label>Access Type :</label>
											{/* <input onChange={this.handleInputChange} type="radio" name="accessType" value="mainTab" checked={(this.state.accessType == "mainTab" ? "checked" : "" )}/>
											Main Tab
											<input onChange={this.handleInputChange} type="radio"  name="accessType" value="ai" checked={(this.state.accessType == "ai" ? "checked" : "" )}/>
											AI Widget */}
											<Select 
												name="accessType"
												value={this.state.selAccessTypeOption? this.state.selAccessTypeOption:{ value: '', label: 'Select'}}
												options={lang.common.tab_access_type} 
												isSearchable = {false}
												//onChange={this.handleOptionChange('accessTypeOption')}
												onChange={(optVal) => this.handleOptionChange(optVal, 'accessTypeOption')}
											/>
											<div className="errorselAccessTypeValue"></div>
										</div> 

										<div className="form-group">
											<label>Icon (jpeg,jpg,png,svg)</label>
											<div className="choose-file">
											{this.state.isHidden && <div className="image_success"></div>}
											<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
											</div>
											{preview}
											{/* {image_preview?<a href="javascript:void(0);">X</a>:''} */}
											<div className="errorimage"></div>  
										</div> 
										
									
										{/* 
										<div className="form-group">					
											<label>Content:</label>
												<textarea type="text" name='content' onChange={this.handleInputChange} className='form-control' value={this.state.content} />
											<div className="errorcontent"></div>
										</div> */}

										
									</div>	
								</div>		
								<div className="btn-group export">	
									<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true? <span>Updating</span>:<span>Submit</span>}
									</button>
								</div>
							</form>
						</div>				
					</div>	
				</div>
					
			</div>
		);
	}
}


// const mapStateTopProps = (state) => {
//   return {
//     categorydetails: state.categorydetails,
//     categoryedit: state.categoryedit
//   }
// }

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getCategoryDetailList: (tabId) =>{
//        dispatch({ type: GET_CATEGORYDETAILLIST,tabId });
//     },
//     getEditCategory: (formPayload) =>{
//        dispatch({ type: GET_EDITCATEGORY, formPayload});
//     }
//   }
// }
export default (withRouter(Edit));